export default __webpack_public_path__ + "static/media/marketplace-mentors.7e04ff86.png";